import { render, staticRenderFns } from "./RoleIcon.vue?vue&type=template&id=2f191f35&scoped=true&"
import script from "./RoleIcon.vue?vue&type=script&lang=js&"
export * from "./RoleIcon.vue?vue&type=script&lang=js&"
import style0 from "./RoleIcon.vue?vue&type=style&index=0&id=2f191f35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f191f35",
  null
  
)

export default component.exports